import React, { useState } from "react";
import Heading from "../ui/Heading";
import { Container, Image } from "react-bootstrap";
import Round from "../Assets/img/diamond-shape/round-diamond.webp";
import Princess from "../Assets/img/diamond-shape/princess-diamond.webp";
import Cushion from "../Assets/img/diamond-shape/cushion-diamond.webp";
import Emerald from "../Assets/img/diamond-shape/emerald-diamond.webp";
import Oval from "../Assets/img/diamond-shape/oval-diamond.webp";
import Radiant from "../Assets/img/diamond-shape/radiant-diamond.webp";
import Asscher from "../Assets/img/diamond-shape/asscher-diamond.webp";
import Marquise from "../Assets/img/diamond-shape/marquise-diamond.webp";
import Heart from "../Assets/img/diamond-shape/heart-diamond.webp";
import Pear from "../Assets/img/diamond-shape/pear-diamond.webp";
import Slider from "react-slick";
import { Link } from 'react-router-dom'
const data = [
  {
    name: "Round",
    para: "Cut with the optimum light refraction and sparkle.",
    image: Round,
    url: "/diamonds/shape=Round",
  },
  {
    name: "Princess",
    para: "A contemporary cut, with optimal fire and brilliance.",
    image: Princess,
    url: "/diamonds/shape=Princess",
  },
  {
    name: "Cushion",
    para:
      "With soft corners, a beautiful alternative to a round or princess cut.",
    image: Cushion,
    url: "/diamonds/shape=Cushion",
  },
  {
    name: "Emerald",
    para:
      "This stylish cut creates rectangular facets with great stone's clarity.",
    image: Emerald,
    url: "/diamonds/shape=Emerald",
  },
  {
    name: "Oval",
    para: "Optimises carat, giving the illusion of a larger stone.",
    image: Oval,
    url: "/diamonds/shape=Oval",
  },
  {
    name: "Radiant",
    para: "The most brilliant of the rectangular cut diamonds.",
    image: Radiant,
    url: "/diamonds/shape=Radiant",
  },
  {
    name: "Asscher",
    para: "This unique shape is a square emerald, with linear facets.",
    image: Asscher,
    url: "/diamonds/shape=Asscher",
  },
  {
    name: "Marquise",
    para: "Elongate the finger of the wearer with a look of great grandeur.",
    image: Marquise,
    url: "/diamonds/shape=Marquise",
  },
  {
    name: "Heart",
    para: "A rare cut that is a true testament of your relationship.",
    image: Heart,
    url: "/diamonds/shape=Heart",
  },
  {
    name: "Pear",
    para: "Combining the brilliance and design of the Round and Marquise cuts.",
    image: Pear,
    url: "/diamonds/shape=Pear",
  },
];

const ShopByDiamondShape = () => {
  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 10,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          dots: false,
          slidesToShow: 8,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
    ],
  };
  const [diamondItem, setDiamondItem] = useState(data[0]);

  return (
    <>
      <section className="shop-diamond-by-shape section-space pb-lg-0">
        <Container fluid className="showcase-container">
          <Heading>
            <h2>SHOP DIAMONDS BY SHAPE</h2>
            <p>Discover Your Perfect Fit.</p>
          </Heading>

          <div className="inner-shop-diamond-shape mx-1440">
            <div className="diamonds-collection ">
              <Slider {...settings}>
                {data.map((item, i) => (
                  <div
                    className="diamond-item cursor-pointer"
                    key={i}
                    onClick={() => setDiamondItem(item)}
                  >
                    <Link to={item.url}>
                      <Image src={item.image} alt="Round" 
                      // style={{
                      //   transform:
                      //     item.name === "Marquise" ? "scale(1.2)" : item.name === "Pear" ? "scale(1.1)" : "",
                      //     transition: "transform 0.3s ease",
                      // }} 
                      />
                      <p className={`${item.name === item.name && "name"}`}>
                        {item.name}
                      </p>
                    </Link>
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        </Container>
      </section>
      {/* {isMobile ? <img className='p-2 img-fluid' src={divider} alt='' /> : ''} */}
    </>
  );
};

export default ShopByDiamondShape;
